import { type ReactNode } from "react";
import { Link } from "wouter";
import { ShieldAlert } from "lucide-react";
import { useRole } from "@/contexts/AuthContext";

/**
 * Garde de rôle : réserve une route au GREFFIER / ADMIN (espace greffe :
 * recevabilité, affectation du tribunal, enrôlement des parties).
 *
 * À utiliser à l'intérieur d'un <ProtectedRoute> (authentification déjà
 * résolue). Côté serveur, ces endpoints sont déjà interdits aux autres rôles
 * (RBAC + ACL) ; ce garde n'est que la barrière UX correspondante — il évite
 * un flash de page non autorisée. On bloque tout rôle ≠ GREFFIER/ADMIN.
 */
export function GreffeOnlyRoute({ children }: { children: ReactNode }) {
  const role = useRole();
  const autorise = role === "GREFFIER" || role === "ADMIN";

  if (!autorise) {
    return (
      <div
        className="min-h-screen flex items-center justify-center px-6"
        style={{ background: "oklch(0.115 0.038 243)", color: "oklch(1 0 0)" }}
      >
        <div className="max-w-md text-center space-y-4">
          <ShieldAlert
            size={40}
            style={{ color: "oklch(0.695 0.105 68)", margin: "0 auto" }}
          />
          <h1 className="text-xl font-semibold">Espace réservé au greffe</h1>
          <p className="text-sm" style={{ opacity: 0.8 }}>
            La recevabilité, la constitution du tribunal et l'enrôlement des
            parties relèvent du greffe (GREFFIER). Vous n'avez pas accès à cet
            espace.
          </p>
          <Link
            href="/dashboard"
            className="inline-block text-sm underline"
            style={{ color: "oklch(0.695 0.105 68)" }}
          >
            ← Retour au tableau de bord
          </Link>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
